import '../paedml-modal.tag'
import '../paedml-form-input.tag'

<paedml-modal-hub-parameters>
  <paedml-modal prefix={opts.prefix} heading={opts.heading} opname={opts.opname} edit={opts.edit} selectedrowsfunc={opts.selectedrowsfunc} idcol={opts.idcol} idtextcol={opts.idtextcol}
    submitfunc={submitHandler}>
  
    <yield to="fields">

      <div class="paedml-input-group">
        <div class="row" show={edit}>
          <div class="col-sm-12">
            <paedml-form-input name="name" col="1" label="Name"
              readonly
            />
          </div>
        </div>
        <div class="row" show={!edit}>
          <div class="col-sm-8 pr-0">
            <paedml-form-input name="name" col="1" label="Name"
              required data-msg="Bitte geben Sie den Namen des Parameters ein"
              data-rule-maxlength="30" data-msg-maxlength="Der Name darf nicht länger als 30 Zeichen sein"
              data-rule-alphanum data-msg-alphanum='Erlaubt sind: Buchstaben, Ziffern.'
            />
          </div>
          <div class="col-sm-4 pl-0">
            <paedml-form-input name="suffix" label="Suffix" readonly />
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <paedml-form-input name="fqdnAddress" col="2" label="FQDN des Ziels"
              required data-msg="Bitte geben Sie den FQDN des Ziels ein"
              data-rule-hubfqdn data-msg-hubfqdn='Erlaubt sind: Domain oder IP-Adresse.'
            />
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <paedml-form-input name="parameter" col="3" label="ProxyPass-Parameter"
              required data-msg="Bitte geben Sie den Parameter für das Umleitungsziel ein"
              data-rule-protocolipaddressport data-msg-protocolipaddressport="Erlabut sind: https://Server-IP (FQDN):Port oder http://Server-IP (FQDN):Port"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <paedml-form-input name="description" col="4" label="Beschreibung"
              required data-msg="Bitte geben Sie die Beschreibung des Parameters ein"
            />
          </div>
        </div>
      </div>
    </yield>
  </paedml-modal>

    <script>
      import {autoMapRowToData} from '../../util/modal-util'
      import { client, handleSubmitCreateOrEdit } from '../../util/api-util'
      import * as R from 'ramda'
      import Session from '../../store/session'
      
      this.opname = this.opts.opname
      this.edit = this.opts.edit ? true : false
      this.data = {}
      this.api = this.opts.api
      this.session = Session
      
      this.on('rowMappingRequested', cols => {
        autoMapRowToData(this, cols)
      })

      this.on('dataRequested', () => {
        $('input[name=suffix]', this.root).val('Hostname')
      })

      this.submitHandler = formData => {
        return handleSubmitCreateOrEdit(this, data => `Parameter "${data.title}"`, data => `Parameter "${data.title}"`, false, true)(formData)
      }
    </script>
</paedml-modal-hub-parameters>
